import { useEffect } from 'react';
import { IoCloseCircle } from 'react-icons/io5';
import { useNavigate, useParams } from 'react-router-dom';

import { check } from "../assets/svg/index.js";

import Spinner from '../Components/CommonComponents/Spinner/index.js';

import { REWARD_LISTING } from '../Routes/RoutesContant.js';

export const SuccessMessage = ({ message }) => {
	return (
		<>
			{message && (
				<div className="flex mt-2 gap-2 text-sm text-[#09CB11] font-Inter font-medium">
					<img src={check} alt="check" />
					{message}
				</div>
			)}
		</>
	)
}

export const ErrorMesage = ({ error, message }) => {
	return (
		<>
			{error && !message && (
				<div className="flex items-center mt-2 gap-2 text-sm text-red-600 font-Inter font-medium">
					<IoCloseCircle color="#e52424" size={18} />
					{error}
				</div>
			)}
		</>
	)
}

// Utility function to get subdomain information
export const getSubdomainInfo = () => {
	const hostname = window.location.hostname;
	const isLocalhost = hostname.includes("localhost");

	let subdomainName = null;
	let isSubdomain = false;

	// Check for subdomain in development environment
	if (isLocalhost) {
		const parts = hostname.split(".");
		// Assuming pattern subdomain.localhost
		if (parts.length > 1 && parts[0] !== "localhost") {
			subdomainName = parts[0];
			isSubdomain = true;
		}
	} else {
		// Check for subdomain in production environment
		const parts = hostname.split(".");
		// Check if there are more than two parts, indicating a subdomain is present
		if (parts.length > 2) {
			subdomainName = parts[0];
			isSubdomain = true;
		}
		// Check for specific subdomain and main domain
		if (subdomainName === "www") {
			isSubdomain = false; // It's the main domain
			subdomainName = null; // Clear subdomain name
		} else if (subdomainName && subdomainName !== "www") {
			isSubdomain = true; // Any other keyword is a valid subdomain
		}
	}

	return { isSubdomain, subdomainName };
};

// Component to handle main domain redirect
export const MainDomainRedirect = () => {
	const { isSubdomain } = getSubdomainInfo();
	const isMainDomain = !isSubdomain;

	useEffect(() => {
		if (isMainDomain) {
			window.location.href = 'https://www.adneto.in/product/bankco';
		}
	}, [isMainDomain]);

	return null;
};

export const formatAmount = (amount) => {
	return new Intl.NumberFormat('en-IN', {
		style: 'decimal',
		maximumFractionDigits: 2
	}).format(amount);

};

// Function to format numbers to Indian currency format
export const formatIndianNumber = (num) => {
	return new Intl.NumberFormat('en-IN', {
		maximumFractionDigits: 2,
		style: 'decimal'
	}).format(num);
};

export const formatDiscountRoundOff = (discount) => {
	const rounded = Number(discount).toFixed(2);
	return rounded.endsWith('.00') ? parseInt(rounded) : parseFloat(rounded);
};

// Date Format Generate

// Array of month names
export const monthNames = ["January", "February", "March", "April", "May", "June",
	"July", "August", "September", "October", "November", "December"
];

// Function to add ordinal suffix to day
export function getOrdinalSuffix(day) {
	if (day > 3 && day < 21) return 'th';
	switch (day % 10) {
		case 1: return "st";
		case 2: return "nd";
		case 3: return "rd";
		default: return "th";
	}
}

export const colorDetect = (status) => {
	if (status === "REFUNDED") {
		return {
			text: "Rejected",
			color: "#e53030",
		}
	} else if (status === "PENDING") {
		return {
			text: "Pending",
			color: "#ffbe41",
		}
	} else if (status === "PROCESSING") {
		return {
			text: "Pending",
			color: "#ffbe41",
		}
	} else if (status === "COMPLETED") {
		return {
			text: "Completed",
			color: "#6dc965",
		}
	} else {
		return {
			text: "Not Available",
			color: "#D9D9D9",
		}
	}
}

// Lighten the color
export const hexToRgb = (hex) => {
	// Remove the hash (#) if present
	const cleanHex = hex?.replace("#", "");
	// Split into R, G, B components
	const bigint = parseInt(cleanHex, 16);
	return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};

// Darken the color
// Utility function to darken a hex color
export const darkenColor = (hex, amount = 20) => {
	let color = hex.replace("#", "");
	if (color.length === 3) {
		color = color
			.split("")
			.map((char) => char + char)
			.join("");
	}
	const r = Math.max(0, Math.min(255, parseInt(color.substring(0, 2), 16) - amount));
	const g = Math.max(0, Math.min(255, parseInt(color.substring(2, 4), 16) - amount));
	const b = Math.max(0, Math.min(255, parseInt(color.substring(4, 6), 16) - amount));
	return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};

export const newTheme = {
	bank: {
		hex_code: "f5437f",
		text_hex_code: "ffffff",
		logo: null
	},
	website_font_family: "Inter",
	website_font_url: "https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"
}
// change in the header component to change intogrator

// Common function for integrator theme color of text and background
export function backgroundColor(theme = newTheme) {
	return theme?.bank?.hex_code ? `#${theme?.bank?.hex_code}` : theme?.brand?.hex_code ? `#${theme?.brand?.hex_code}` : "#F5437E";
}
export function textColor(theme = newTheme) {
	return theme?.bank?.text_hex_code ? `#${theme?.bank?.text_hex_code}` : theme?.brand?.text_hex_code ? `#${theme?.brand?.text_hex_code}` : "#FFFFFF";
}

export function defaultTextColor(theme = newTheme) {
	return theme?.bank?.hex_code ? `#${theme?.bank?.hex_code}` : theme?.brand?.hex_code ? `#${theme?.brand?.hex_code}` : "#F5437E";
}

const SubscriptionColor = {
	Offer: "#F5437E",
	Active: "#0AA910",
	Expiring: "#F58220",
	Expired: "#fa0e00"
}

// subscription related functions 
export function subscritptionDefaultColor(text) {
	return SubscriptionColor[text] || "#F5437E"
}

export const getSubscriptionBySlug = (subscriptionData, slug) => {
	// Return first item if array is empty or no slug provided
	if (!subscriptionData?.length || !slug) {
		return subscriptionData[0];
	}

	// Find subscription matching the slug
	const matchedSubscription = subscriptionData.find(
		subscription => subscription.slug === slug
	);

	// Return matched subscription or first item as fallback
	return matchedSubscription || subscriptionData[0];
};

// subscription data 
export const getStatusColor = (status) => {
	switch (status.toLowerCase()) {
		case 'paid':
			return 'border-[#58C3A8] text-[#58C3A8] px-5 py-2 border-2';
		case 'pending':
			return 'border-[#EFAF2D] text-[#EFAF2D] px-5 py-2 border-2';
		case 'failed':
			return 'border-[#E62929] text-[#E62929] px-5 py-2 border-2';
		default:
			return 'border-gray-600 text-gray-600 px-5 py-2 border-2';
	}
};

export const stopDetails = {
	1: { label: "Non Stop", color: "green" },
	2: { label: "1 Stop", color: "orange" },
	3: { label: "2+ Stops", color: "red" },
};

export function isPublicPage() {
	// Get the current URL path
	const currentPath = window.location.pathname;

	// Remove leading and trailing slashes for consistent comparison
	const normalizedPath = currentPath?.replace(/^\/|\/$/g, '');

	// Define patterns for public reward pages
	const publicRewardPatterns = [
		/^rewards\/[^/]+\/[^/]+\/[^/]+\/[^/]+$/, // Public reward detail page
		/^rewards\/[^/]+\/[^/]+$/, // Public reward listing page
		/^deals$/, // Public reward listing page
	];

	// Check if the path matches any public pattern
	return publicRewardPatterns?.some(pattern => pattern?.test(normalizedPath));
}

// * Generates a dynamic background image URL based on the screen size(mobile or desktop).
//  * Handles cases where the URL is null or invalid.
export const getDynamicBackgroundImageUrl = (url, isMobile) => {
	if (!url) {
		return ""; // Return empty string if the URL is null or undefined
	}

	try {
		// Only modify URL for mobile view
		if (isMobile) {
			// Case 1: Handle bg_image pattern URLs
			const bgImageParts = url.split("/bg_image/");
			if (bgImageParts.length === 2) {
				return `${bgImageParts[0]}/bg_image/mobile/${bgImageParts[1]}`;
			}

			// Case 2: Handle other URL patterns by inserting "mobile" before the last segment
			const urlObj = new URL(url);
			const pathParts = urlObj.pathname.split('/');

			// If there's at least one path segment
			if (pathParts.length > 1) {
				// Insert "mobile" before the last path segment
				pathParts.splice(pathParts.length - 1, 0, "mobile");

				// Reconstruct the URL
				urlObj.pathname = pathParts.join('/');
				return urlObj.toString();
			}
		}

		// Return the original URL if it's desktop view or if the URL structure is invalid
		return url;
	} catch (error) {
		console.error("Error generating background image URL:", error);
		return ""; // Return empty string in case of any error
	}
};

// Helper function to convert month abbreviation to month number
export const getMonthNumber = (monthAbbr) => {
	const months = {
		'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6,
		'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12
	};
	return months[monthAbbr] || 1;
};

// Helper function to get departure date and time as a timestamp
export const getDepartureDateTime = (flight, fromCityCode) => {
	if (!flight || !flight.Bonds || !flight.Bonds[0] || !flight.Bonds[0].Legs) {
		return 0; // Return default value if structure isn't as expected
	}

	// Find the leg where the Origin matches the fromCityCode
	const matchingLeg = flight.Bonds[0].Legs.find(leg => leg?.Origin === fromCityCode);

	if (matchingLeg) {
		// Parse departure date and time into a timestamp
		const dateStr = matchingLeg.DepartureDate;
		const timeStr = matchingLeg.DepartureTime;

		// Handle date format like "Wed-26Feb2025"
		const [_, day, monthYear] = dateStr.match(/(\d+)([A-Za-z]+)(\d+)/) || [];
		const month = getMonthNumber(monthYear.slice(0, 3));
		const year = monthYear.slice(3);

		// Parse time in 24-hour format like "21:20"
		const [hours, minutes] = timeStr.split(':').map(Number);

		const timestamp = new Date(year, month - 1, day, hours, minutes).getTime();
		return timestamp;
	} else {
		// If no match is found, use the first leg's departure time as fallback
		const firstLeg = flight.Bonds[0].Legs[0];
		const dateStr = firstLeg.DepartureDate;
		const timeStr = firstLeg.DepartureTime;

		// Handle date format like "Wed-26Feb2025"
		const [_, day, monthYear] = dateStr.match(/([A-Za-z]+)-(\d+)([A-Za-z]+)(\d+)/) || [];
		const month = getMonthNumber(monthYear.slice(0, 3));
		const year = monthYear.slice(3);

		// Parse time in 24-hour format like "21:20"
		const [hours, minutes] = timeStr.split(':').map(Number);

		const timestamp = new Date(year, month - 1, day, hours, minutes).getTime();
		return timestamp;
	}

}

// Add this new component to handle parameter extraction and redirection
export const PublicRewardRedirect = () => {
	localStorage.removeItem('rewardIntegratorId');
	localStorage.removeItem('rewardSubId');
	const { integratorId, subId } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		// Only run this once when the component mounts
		if (integratorId && subId) {
			// Save parameters to localStorage
			localStorage.setItem('rewardIntegratorId', integratorId);
			localStorage.setItem('rewardSubId', subId);

			// Redirect to public reward listing page (using navigate instead of Navigate component)
			navigate(`/${REWARD_LISTING}/${integratorId}/${subId}`, { replace: true });
		}
	}, [integratorId, subId, navigate]);

	// Return null or a loading indicator while redirecting
	return <Spinner />;
};

export function HighlightedText({ text, integratorTheme }) {
	// Match all text wrapped in #* and #* and split into parts
	const parts = text?.split(/(#\*.*?#\*)/)?.filter(Boolean);

	return (
		<div>
			{parts?.map((part, index) => {
				if (part?.startsWith("#*") && part?.endsWith("#*")) {
					// Remove the #* markers and wrap in span with highlight class
					const highlightedText = part?.slice(2, -2);

					return <span key={index} style={{ color: defaultTextColor(integratorTheme) }} className="font-semibold">{highlightedText}</span>;
				}

				// Render regular text
				return <span key={index}>{part}</span>;
			})}
		</div>
	);
};

// function to show loyalty points is available in module
export const showLoyaltyPoint = (theme) => {
	const baseModuleKeys = Object.keys(theme?.modules || {});
	const isLoyalityAvailable = baseModuleKeys?.includes("loyalty");
	return isLoyalityAvailable
}